import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/notifications"); setItems(data); };
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="ph-label">Inbox</p>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Mitteilungen</h1>
          <p className="text-slate-500 text-sm mt-1">Aktuelle Hinweise zu Anträgen, Aufgaben und Dokumenten.</p>
        </div>
        <Button variant="outline" onClick={markAll} data-testid="btn-read-all">
          <CheckCheck className="h-4 w-4 mr-2" /> Alle als gelesen
        </Button>
      </div>
      {items.length === 0 ? (
        <div className="ph-card p-12 text-center text-slate-400 text-sm">
          <Bell className="h-8 w-8 mx-auto mb-2 text-slate-300" />
          Keine Mitteilungen.
        </div>
      ) : (
        <ul className="space-y-2">
          {items.map((n) => (
            <li key={n.id} className={`ph-card p-4 flex items-start gap-3 ${!n.read && "border-sky-200 bg-sky-50/40"}`}>
              <div className={`h-9 w-9 rounded-md grid place-items-center ${n.read ? "bg-slate-50 text-slate-400 border border-slate-200" : "bg-sky-100 text-sky-700"}`}>
                <Bell className="h-4 w-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-slate-900">{n.title}</div>
                <div className="text-xs text-slate-600 mt-0.5">{n.message}</div>
                <div className="text-[10px] uppercase tracking-wider text-slate-400 mt-1">
                  {new Date(n.created_at).toLocaleString("de-DE")}
                </div>
              </div>
              {!n.read && (
                <Button variant="outline" size="sm" className="h-8" onClick={() => markOne(n.id)}>
                  Gelesen
                </Button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
